import { validateFormat } from '@/common/validator/validatorHelpers';
import { useCrudActions } from '@/common/view/useCrudActions';
import { slotService } from '@/services/slot';
import useVuelidate from '@vuelidate/core';
import { integer, maxValue, minValue, required } from '@vuelidate/validators';
import { reactive } from 'vue';

export function useSlot() {
    const crudAction = useCrudActions();

    const model = reactive({
        isNew: true,
        price: '',
        notificationValue: null,
        jackpotPrize: null,
        jackpotDonationPercent: 0,
        jackpotWinPercent: 0
    });

    const validations = {
        price: {
            required,
            format: validateFormat(/^\d+(,\d+)*$/, 'Please enter in the correct format: Ex: 2,3,5 [in integer numbers]')
        },
        notificationValue: { required, integer },
        jackpotPrize: { required, integer },
        jackpotDonationPercent: { required, integer, minValue: minValue(0), maxValue: maxValue(100) },
        jackpotWinPercent: { required, integer, minValue: minValue(0), maxValue: maxValue(100) }
    };

    const v$ = useVuelidate(validations, model);

    const fetch = crudAction.executeAction({
        request: slotService().get,
        onSuccess: ({ data }) => {
            model.isNew = false;
            Object.assign(model, data);
        },
        onError: () => {
            model.isNew = true;
            model.price = '';
            model.notificationValue = null;
            model.jackpotPrize = null;
            model.jackpotDonationPercent = 0;
            model.jackpotWinPercent = 0;
        },
        onFinally: () => v$.value.$reset()
    });

    const actions = {
        update: crudAction.excuteAndNotify({
            validator: v$,
            request: () =>
                slotService().update(
                    model.price,
                    model.notificationValue,
                    model.jackpotPrize,
                    model.jackpotDonationPercent,
                    model.jackpotWinPercent
                ),
            onSuccess: fetch
        }),

        remove: crudAction.confirmAndRemove({
            request: slotService().remove,
            onSuccess: fetch
        })
    };

    return { model, v$, fetch, actions };
}
